export default __webpack_public_path__ + "static/media/puzzle.0b3894d0.png";